import { render } from "./home_modules.vue?vue&type=template&id=084db814"
import script from "./home_modules.vue?vue&type=script&lang=js"
export * from "./home_modules.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__